import actions from "@/store/modules/entrance-exit-preview/actions";
import mutations from "@/store/modules/entrance-exit-preview/mutations";
import state from "@/store/modules/entrance-exit-preview/state";

export default {
    actions,
    mutations,
    state
}